<template>
  <div
    v-if="data.WOType === 'Down Time'"
    class="template-wrap week-event-template"
    v-bind:class="computedClass"
  >
    <div class="description">
      <!-- <span>{{ data.ProductCode }}</span> -
      <span>{{ data.ProductDescription1 }} </span> -->
    </div>
  </div>

  <div v-else-if="data.WOType === 'Note'" class="template-wrap schedule-note">
    <div>
      <span>Schedule Note</span>
      <span>{{ getTime(data.StartDate) }} - {{ getTime(data.EndDate) }}</span>
      <span> {{ getWrappedDescription(data.Comments) }} </span>
    </div>
  </div>
  <div
    v-else
    class="template-wrap week-event-template"
    v-bind:class="computedClass"
  >
    <div class="subject">
      <div class="group-1">
        <span>{{ data.subject }}</span>
      </div>
      <span>
        {{ data.FriendlyStatus }}
      </span>
    </div>
    <div class="description">
      <span>{{ data.ProductCode }}</span
      ><br />
      <span>{{ data.ProductDescription1 }} </span>
    </div>
    <div class="data">
      <div class="planned">
        <span>Planned </span>&nbsp;
        <span>
          {{ getFormattedQty(data.RequiredQty) }}
          {{ data.StockUM }}
        </span>
      </div>
      <div class="actual">
        <div class="actual-items">
          <!-- <span>Actual</span>&nbsp;
          <span>
            {{ getFormattedQty(data.RequiredQty) }}
            {{ data.StockUM }}
          </span> -->
        </div>
        <GcCommentIcon v-if="data.HasNote === 'Y'" class="calendar-comment" />
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import GcCommentIcon from "../gc-comment-icon.vue";

export default {
  components: { GcCommentIcon },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    /**
     * Format time from date
     * @param date
     */
    getTime(date) {
      const d = new Date(new Date(date).toISOString().replace("Z", ""));
      let hours = d.getHours();
      let minutes = d.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      const strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },

    /**
     * Wrap description if too long
     * @param description
     */
    getWrappedDescription(description) {
      if (description && description.length > 50) {
        return description.substring(0, 47) + "...";
      }
      return description;
    },
  },
  computed: {
    computedClass() {
      if (this.data.WOType === "Maintenance")
        return {
          maintenance: true,
        };
      if (this.data.WOType === "Down Time")
        return {
          downTime: true,
        };
      else {
        const status = this.data.FriendlyStatus
          ? this.data.FriendlyStatus.toFriendlyStatus()
          : false;
        return {
          active: status === "Awaiting Production",
          inproduction: status === "In Production",
          completed: status === "Completed",
          cancelled: status === "Cancelled",
          draft: status === "Draft",
          planning: status == "Planning",
          review: status == "Review",
        };
      }
    },
  },
};
</script>

<style lang="scss">
.e-appointment-details {
  .maintenance {
    background-color: gray;
  }

  .active {
    background: #62d26f;
  }

  .inproduction {
    background-color: #ffa500;
  }

  .completed {
    background-color: #4186e0;
  }

  .cancelled {
    background-color: #e8384f;
  }

  .planning {
    background-color: #8b5cf6;
  }
  .review {
    background-color: #ff6f61;
  }

  .week-event-template {
    padding: 5px 5px;
    height: 100%;
    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .subject > span {
      font-size: 10px;
    }

    .description {
      font-size: 12px;

      span:last-child {
        text-wrap: wrap;
      }
    }

    .data {
      font-size: 10px;
      display: flex;
      justify-content: space-between;
      // .planned {
      //   padding-right: 25px;
      // }
      .actual {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
    }

    @media screen and (max-width: 1750px) {
      .data {
        flex-direction: column;

        .actual {
          flex-direction: unset;
        }
      }
    }
  }

  .schedule-note {
    background: var(
      --Component-colors-Utility-Error-utility-error-100,
      #fee4e2
    );
    height: 100%;

    > div {
      display: flex;
      flex-direction: column;
      padding: 2px 4px;

      > span:first-child {
        font-family: Inter;
        font-weight: 600;
        font-size: 12px;
        leading-trim: NONE;
        line-height: 18px;
        letter-spacing: 0%;
        color: var(--colors-text-text-tertiary-600, #475467);
      }

      > span:not(:first-child) {
        font-family: Roboto;
        font-weight: 400;
        font-size: 12px;
        leading-trim: NONE;
        line-height: 18px;
        letter-spacing: 0%;
        color: var(--colors-text-text-quaternary-500, #667085);
      }
    }
  }
}
</style>
